<template>
  <td :class="{'key': isKey, 'modal-td': isModal }" >
      <router-link v-if="isKey && linkable" :to="{ name: url, params: { id: fieldValue} }">
        {{ fieldValue }}
      </router-link>
      <span v-if="!isKey || !linkable" @click="clickAction(fieldValue)"
      :style="expand?'cursor:pointer;color:#009c95':''">
          <span v-if="mappers && mappers[fieldName] && !editing">
            <slot :name="fieldName" v-bind:obj="{ value: fieldValue, formated: toString(mappers[fieldName][fieldValue]) }">{{ mappers[fieldName][fieldValue] | toString }}</slot>
          </span>
          <span v-if="fieldValue && (!mappers || !mappers[fieldName]) && !editing">
            <slot :name="fieldName" v-bind:obj="{ value: fieldValue, formated: toString(fieldValue) }">{{ fieldValue | toString }}</slot>
          </span>
          <span v-if="tooltip" class="fa fa-question-circle-o ico"></span>
          <span v-if="editable && !editing" class="fa fa-edit fa-2x" style="float: right" @click="edit()"></span>
          <span class="editing" v-if="editable && editing && editable.type == 'input'">
            <input class="client-code" ref="client_code" type="text" v-model="newValue" @keypress.enter="update()"/>
            <span class="fa fa-check fa-lg" @click="saveChanges()"/><!-- 
          --><span class="fa fa-close fa-lg" @click="editing=false; newValue=''"/>
          </span>
          <span class="editing" v-if="editable && editing && editable.type == 'combo'">
            <div class="select">
              <select  type="text" v-model="newValue" @keypress.enter="update()">
                <option v-for="listChild in editable.list" :key="listChild.id" :value="listChild.id">{{ listChild.name }}</option>
              </select>
            </div>
            <span class="fa fa-check fa-lg" @click="saveChanges()"/><!-- 
          --><span class="fa fa-close fa-lg" @click="editing=false; newValue=''"/>
          </span>
      </span>
      <span v-if="tooltip" class="tooltip">{{tooltip}}</span>
  </td>
</template>

<script>
import {mapActions} from 'vuex'
import moment from 'moment'

export default {
  name: 'data-table-cell',
  props: ['fieldValue', 'fieldName', 'objectKey', 'url', 'mappers', 'tooltip', 'expand', 'editable', 'editUrl', 'keyField', 'isModal'],
  data () {
    return {
      editing: false,
      newValue: ''
    }
  },
  computed: {
    isKey () {
      return this.fieldName === this.objectKey
    },
    linkable () {
      return this.url
    }
  },
  filters: {
    toString: function (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateTimeString = moment(value).format('YYYY-MM-DD HH:mm')
        return dateTimeString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    }
  },
  methods: {
    ...mapActions({
      updateValue: 'partialUpdate'
    }),
    toString (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateTimeString = moment(value).format('YYYY-MM-DD HH:mm')
        return dateTimeString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    },
    edit () {
      if (this.editable.type === 'input') {
        this.newValue = this.fieldValue
      } else if (this.editable.type === 'combo') {
        this.newValue = this.fieldValue.id
      }
      this.editing = true
    },
    saveChanges () {
      if (this.editUrl) {
        var data = {}
        data[this.fieldName] = this.newValue
        var config = {modelClass: {defaults: () => { return {basePath: this.editUrl, name: this.fieldName} }, rawNew: true}, id: this.keyField, data: data}
        this.updateValue(config).then((response) => {
          this.editing = false
          if (this.editable.type === 'input') {
            this.fieldValue = this.newValue
          } else if (this.editable.type === 'combo') {
            this.fieldValue = this.editable.list.filter(item => item.id === this.newValue)[0]
          }
        })
      }
    },
    clickAction (fieldValue) {
      if (this.expand) {
        this.$emit('expand')
      } else if (this.isModal) {
        this.$emit('modal')
      }
    }
  }
}
</script>
<style lang="scss">
.tooltip{
  position: absolute;
  background: white;
  padding: .5em 1em;
  border: 1px solid #999999;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear .5s, opacity 0.2s linear;
}
.ico{
  font-size: 1.3em;
}
td:hover{
  .tooltip{
    visibility: visible;
    opacity: 1;
  }
  .ico {
    color: #009c95;
  }
}
.fa-edit {
  cursor: pointer;
}
.editing {
  white-space: nowrap;
}
.modal-td {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DataTableCell.vue